import axios from '~/constants/axiosConfig';

export async function salvarContrato(data) {
  const route = 'PropostaContrato';

  return axios.post(route, data).then((response) => {
    const { status } = response;
    return status;
  });
}

export async function editarContrato(data) {
  const route = `PropostaContrato/${data.id}`;

  return axios.put(route, data).then((response) => {
    const { status } = response;
    return status;
  });
}
